var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{attrs:{"type":"text","name":"phone","show-mask":true,"mask":['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }